import { useContext } from 'react';
import { useRouter } from '@packages/shared/core/common/hooks';
import QuizStep from '@packages/shared/core/common/components/QuizSteps';
import { QuizContext } from '@packages/shared/core/quiz/context';
import { PagePath } from '@packages/shared/core/common/constants/routes';
import SimpleSimpleRegistrationQuizScreen from './SimpleSimpleRegistrationQuizScreen';

const SimpleRegistrationQuizSteps = ({ pageId }: { pageId: string }) => {
  const router = useRouter();

  const { getStepData } = useContext(QuizContext);

  const stepData = getStepData((router.query.id as string) || pageId);

  if (!stepData) {
    router.push(PagePath.SIMPLE_SIMPLE_REGISTRATION_QUIZ_GENDER);
    return null;
  }

  return <QuizStep stepData={stepData} renderQuizScreen={SimpleSimpleRegistrationQuizScreen} />;
};

export default SimpleRegistrationQuizSteps;
